import { QuickQuestionOption } from '@gelato-api-ui/core/quick-questions/constants/quck-question-option';
import { RefererOptionIdsEnum } from '@gelato-api-ui/core/quick-questions/types/referer-option-ids.enum';
import { QuickQuestionCommonOptionsEnum } from '@gelato-api-ui/core/quick-questions/types/quick-question-common-options.enum';

export const RefererOptions: QuickQuestionOption[] = [
  { id: RefererOptionIdsEnum.WordOfMouth, name: 'txt_question_title_word_of_mouth' },
  { id: RefererOptionIdsEnum.OnlineSearch, name: 'txt_question_title_online_search' },
  { id: RefererOptionIdsEnum.ReviewSite, name: 'txt_question_title_review_site' },
  { id: RefererOptionIdsEnum.Blog, name: 'txt_question_title_blog' },
  { id: RefererOptionIdsEnum.SocialMedia, name: 'txt_question_title_social_media' },
  { id: RefererOptionIdsEnum.Influencer, name: 'txt_question_title_influencer' },
  { id: RefererOptionIdsEnum.Podcast, name: 'txt_question_title_podcast' },
  { id: QuickQuestionCommonOptionsEnum.Other, name: 'txt_other' },
];
